import axios from "axios";
import { refreshAccessTokenInterceptor } from "../utils/refreshTokens";
import { fullAPIURL } from "../utils/requests";
import {
  requestAccessTokenInterceptor,
  responseStatusInterceptor,
} from "../utils/axios.utils";
import { CelebrationType } from './metricsApi';
import { PlanForm } from "src/pages/Plans/PlanDrawer/PlanDrawer.types";

const aiAxios = axios.create({
  baseURL: `${fullAPIURL}/v2/ai`,
  headers: { "Content-Type": "application/json" },
  validateStatus: null,
});

aiAxios.interceptors.request.use(requestAccessTokenInterceptor);

aiAxios.interceptors.request.use(refreshAccessTokenInterceptor);

aiAxios.interceptors.response.use(responseStatusInterceptor);

export type CompletionResponse = {
  completion: string;
};

export type TextType = "confirmationMessage" | "shortDescription" | "longDescription";

export async function postOutreachSms({
  memberName,
  gymName,
  numberOfYears,
  celebrationType
}: {
  memberName: string;
  gymName: string;
  numberOfYears?: number;
  celebrationType: CelebrationType;
}): Promise<CompletionResponse> {

  if (celebrationType === "birthday") {
    const response = await aiAxios.post('/outreach/sms/birthday', { memberName, gymName });
    return response.data;
  } else if (celebrationType === "anniversary") {
    const response = await aiAxios.post('/outreach/sms/anniversary', { memberName, gymName, numberOfYears });
    return response.data;
  }
  else {
    throw new Error("Invalid celebration type");
  }
}

export async function generatePlanText({
  textType,
  plan
}: {
  textType: TextType;
  plan: PlanForm;
}): Promise<CompletionResponse> {
  const response = await aiAxios.post('/generate-plan-text', { type: textType, plan });
  return response.data;
}
